export const Constants = {
  title: 'Financeiro',
  subtitle: 'Gestão de pagamentos, faturamento e indicadores.',
  totalPayed: 'Total Pago (mês)',
  totalPending: 'Pendente / Faturado',
  pending: 'Pagamentos Pendentes',
  status: 'status',
  year: 'ano',
  month: 'mês',
  allHistory: 'Todo o histórico',
  clearSearch: 'limpar busca por status',
  searchPlaceholder: 'buscar OS ou credenciado',
  paymentNumber: 'n° pagamento',
  licensed: 'credenciado',
  notice: 'edital',
  value: 'valor',
  referencePeriod: 'período de referência',
  finishDate: 'data de finalização',
  actions: 'ações',
  noPayments: 'Nenhum pagamento encontrado',
  totalValue: 'valor total',
  paymentInfo: 'Informações do pagamento',
  files: 'Arquivos',
  associatedWorkOrders: 'OS atreladas',
  noAssociatedWorkOrders: 'Nenhuma OS atrelada a este pagamento',
  createdAt: 'data de criação',
  finishedAt: 'finalização',
  selectFile: 'selecionar arquivo',
  invoice: 'faturar',
  approvedAt: 'data de aprovação',
  invoicedAt: 'data de faturamento',
  paidAt: 'data de pagamento',
  confirmInvoice: 'confirmar faturamento',
  pay: 'pagar',
  registerPayment: 'Registrar pagamento',
  valueInvoiced: 'valor faturado',
  paymentDate: 'data do pagamento',
  confirmPayment: 'confirmar pagamento',
  confirm: 'confirmar',
  refundPayment: 'estornar pagamento',
  cancelPayment: 'cancelar pagamento',
  pendingOnly: 'Exibindo todos os pagamentos pendentes do histórico completo',
  add: 'adicionar',
  paid: 'pago',
  cancelled: 'cancelado',
  refunded: 'estornado',
  refund: 'estornar',
  cancellation: 'cancelamento',
  chargeback: 'estorno',
  cancel: 'cancelar',
  approve: 'aprovar',
  confirmAction: 'Você confirma o {{action_type}} do pagamento?',
  reason: 'Motivo:',
};
